<template>
	<div class="">
		<Header></Header>
		<van-row class="Calendarmore w95">
			<p>日历列表</p>
			<p @click="showPopup"><img src="../assets/about/serch.png" alt=""></p>
			<p @click="showPopup">筛选</p>
		</van-row>
		<van-row class='tablist w95'>
			<van-row type='flex' class='taltop'>
				
				<van-col span='6'>报名开始时间</van-col>
				<van-col span='6'>报名结束时间</van-col>
				<van-col span='6'>考试时间</van-col>
				<van-col span='6'>详细公告</van-col>
			</van-row>
			<van-row type='flex' class='tbody' v-for='(item,index) in dataList' :key='index'>
				<van-col span='6'>{{item.signUpTimeStart  | dateFormat1}}</van-col>
				<van-col span='6'>{{item.signUpTimeEnd  | dateFormat1}}</van-col>
				<van-col span='6'>{{item.examTime  | dateFormat1}}</van-col>
				<van-col span='6' class='look'><a :href="item.examChannel">查看</a> </van-col>
			</van-row>
		</van-row>
		<Fotter></Fotter>
		<div class="addreschose" v-if="show">
				<div class="addbox">
				 <div class="addresS">
					 <p>考试类型</p>
					 <ul>
						<li v-for="(item,index) in typeData" :key="index" v-bind:class="{blue:index==current1}"  @click="ontype(item.id,item.code,index)">{{item.name}}</li>
					 </ul>
				 </div>
				  <div class="addresS">
					 <p>所在省份</p>
					<ul>
						<li v-for="(item,index) in treeList" :key="item.id" v-bind:class="{ blue1:index==current2}"   @click="clickItem(item.children,item.id,item.code,index)">
							{{item.name}}
					   	</li>
					 </ul>
				  </div>
				   <div class="addresS">
					 <p>所在地区</p>
					  <ul>
					<li v-for="(item,index) in twoData" :key="item.id" v-bind:class="{ blue2:index==current3}"  @click="clickItem1(item.id,item.code,index)">
						{{item.name}} 
					</li>
					 </ul>
				  </div>
				 <div class="addresS">
					 <p>考试年份</p>
					 <ul>
						<li v-for="(item,index)  in yeardata" :key="index" v-bind:class="{ blue3:index==current4}"  @click="clickItem2(item.year,index)">
							{{item.year}}年
						</li>
					 </ul>
				</div>
				 <div class="addresS">
					 <p>考试月份</p>
					 <ul>
					   	<li v-for="(item,index)  in moundata" :key="index" v-bind:class="{ blue4:index==current5}"  @click="clickItem3(item.mon,index)">
							{{item.mon}}月
						</li>
					 </ul>
				</div>
				 <div class="dbbtn">
					  <p @click="hideaddreschose">取消</p>
					  <p @click="onsuccess">确定</p>
				 </div>
			</div>
		</div>	
	</div>
</template>
<script>
	import Header from "./Header.vue";
	import Fotter from "./Fotter.vue";
	import __Config from '../api/config';
	export default {
		name: 'Calendarmore',
		components: {
			Header,
			Fotter
		},
		data() {
			return {
				current1:-1,
				current2:-1,
				current3:-1,
				current4:-1,
				current5:-1,
				show:false,
				treeList:[],//省
				twoData:[],//地区
				typeData:[],//考试类型
				dataList:[],//日历
				yeardata:[
					{"year":2015},
					{"year":2016},
					{"year":2017},
					{"year":2018},
					{"year":2019},
					{"year":2020},
					{"year":2021}
				],
				moundata:[
                  {"mon":1}, {"mon":2}, {"mon":3}, {"mon":4}, {"mon":5}, {"mon":6}, {"mon":7}, {"mon":8}, {"mon":9}, {"mon":10}, {"mon":11}, {"mon":12}
				],
			    siteId:this.$store.state.treeData.id,
				siteCode:this.$store.state.treeData.code,
				moduleId:"",
				moduleCode:"",
				year:"",
				month:"",
			}

		},
		methods: {
			//获取考试日列
			getCalendars(){
				 this.$toast.loading({
					duration: 0,  
					mask: true,
					message: '加载中...'
				});
                var that = this;
                this.$axios.get(__Config.api.getCalendar,{
                params: {
					pageNo:1,
					pageSize:20,
					siteId:this.siteId,
					siteCode:this.siteCode,
					moduleId:this.moduleId,
					moduleCode:this.moduleCode,
					year:this.year,
					month:this.month,
			      }
                })
                .then(function (res) {
				that.$toast.clear();
                  //console.log(res);
                  that.dataList = res.data.data;
                })
                .catch(function (err) {
					that.$toast.clear();
                    console.log(err);
                });
			},

			//考试类型
			getexamTypes(){
                 var that = this;
                 this.$axios.get(__Config.api.getexamType,{
             
                 })
                .then(function (res) {
                   // console.log(res);
                    that.typeData = res.data.data;
                })
                .catch(function (err) {
                    console.log(err);
                });
			},
			//点击考试类型
			ontype(id,code,index){
				this.moduleId=id;
				this.moduleCode=code;
				this.current1 = index;
				this.getCalendars();
			},
				//获取站点
			getTree(){
				var that = this;
				this.$axios.get(__Config.api.gettree,{
					params: {
						siteId:0
					}
				})
				.then(function (res) {
				       //拿到 所有的省
				    	that.treeList= res.data.data[0].children;
					})
				.catch(function (err) {
					console.log(err);
					});
				},
			//点击一级省
				//点击一级
			clickItem(data,id,code,index){
				this.twoData= data;
				this.siteId = id;
				this.siteCode =code;
				this.current2=index;
				//再次拉去数据
             this.getCalendars();
				
			},
				//点击diqu
			clickItem1(id,code,index){
				this.siteId = id;
				this.siteCode =code;
				this.current3=index;
				//再次拉去数据
               this.getCalendars();
			},
			//年份
			clickItem2(year,index){
			  this.year= year;
			  this.current4 = index;
			  this.getCalendars();
			},
				//月
			clickItem3(month,index){
			  this.month= month;
			  this.current5 = index;
			  this.getCalendars();
			},
           showPopup(){
			   this.show=true;
		   },
		   //取消
		   hideaddreschose(){
				this.show=false;
				this.siteId=this.$store.state.treeData.id,
				this.siteCode=this.$store.state.treeData.code,
                this.moduleId="",
				this.moduleCode="",
				this.year="",
				this.month="",
				this.current1=-1,
				this.current2=-1,
				this.current3=-1,
				this.current4=-1,
				this.getCalendars();
		   },
		   onsuccess(){
             this.show=false;
		   },
		   //详情
		   openDeatil(){
			    this.$router.push({  
			   	path: '/Calendar_detail',   
			   	name: '',  
			   	params: {   
			   		key: 'key',   
			   	}  
			   	
			   })  
		   }
		},
		created(){
			this.getCalendars();
			this.getexamTypes();
			this.getTree();
		}
	}
</script>
<style scoped>
	.blue{
		background: rgba(0, 124, 207, 1);
		color: #fff;
	}
	.blue1{
		background: rgba(0, 124, 207, 1);
		color: #fff;
	}
	.blue2{
		background: rgba(0, 124, 207, 1);
		color: #fff;
	}
		.blue3{
		background: rgba(0, 124, 207, 1);
		color: #fff;
	}
		.blue4{
		background: rgba(0, 124, 207, 1);
		color: #fff;
	}
	.Calendarmore {
		margin: 20px auto;
		display: flex;
		height: 40px;
	}
	.Calendarmore p:nth-child(1) {
		flex: 1;
		line-height: 40px;
		font-size: 12px;
		font-weight: 600;
		color: rgba(51, 51, 51, 1);
	}
	.Calendarmore p:nth-child(2) {
		width: 30px;
	}
	.Calendarmore p:nth-child(2) img {
		width: 22px;
		height: 28px;
		margin: 5px;
	}
	.Calendarmore p:nth-child(3) {
		width: 50px;
		text-align: center;
		line-height: 40px;
		font-size: 15px;
		font-weight: 400;
		color: rgba(102, 102, 102, 1);
	}
	.tablist {
		margin: 20px auto;
	}
	.tablist table {
		width: 100%;
	}
	.taltop {
		background: #007CCF;
    color: #fff;
    font-size: 0.5rem;
    text-align: center;
    margin: 13px 0px 10px 0px;
    height: 24px;
    line-height: 38px;
	}
	.tbody {
		font-size: 10px;
		font-weight: 200;
		height: 54px;
		color: rgba(102, 102, 102, 1);
		margin-top: 5px;
		overflow: hidden;
		text-align: center;
	}
	.look  a{
		color: #007CCF;
	}
	.tablist .tbody:nth-child(even) {
		background: #fff;
	}
	.van-col {
		float: left;
		box-sizing: border-box;
		min-height: 1px;
		line-height: 25px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Calendarmore.vue